import React from 'react';
import PropTypes from 'prop-types';
import { Radio } from 'antd';
import {
  Radio as RadioGroup, Form, Button, FormItem,
} from 'components/common';

import { withTranslation } from 'language/i18n';
import { USER_MEMBERSHIP_TYPE } from 'constants/common';

const MembershipType = ({
  t, updateUserState, router, userState,
}) => {
  const onFormSubmit = () => {
    localStorage.setItem('membershipType', userState.membershipType);
    router.push({
      pathname: '/register/create-profile',
    });
  };

  return (
    <div className="col-md-10 col-lg-6 offset-lg-1 mt-5 mt-lg-0">
      <Form layout="vertical" onFinish={onFormSubmit}>
        <div className="fs-22 mb-2">{t('stepNumber', { step: 1 })}</div>
        <div className="fs-22 fw-900 mb-3">{t('selectMembershipType')}</div>
        <div className="mb-5">Size daha kolay yardımcı olabilmemiz için üyelik türünüzü seçiniz.</div>

        <FormItem
          name="membershipType"
          rules={[{ required: true, message: t('cantBeEmpty') }]}
        >
          <RadioGroup
            onChange={(event) => updateUserState({ name: 'membershipType', value: event.value })}
            groupStyle={{ width: '100%' }}
          >
            <Radio
              className="im-box im-box--white mb-2 im-box--shadow im-box--padding-15"
              style={{ width: '100%' }}
              value={USER_MEMBERSHIP_TYPE.CORPORATE}
            >
              Kurumsal Üyelik
            </Radio>

            <Radio
              className="im-box im-box--white mb-2 im-box--shadow im-box--padding-15"
              style={{ width: '100%' }}
              value={USER_MEMBERSHIP_TYPE.INDIVIDUAL}
            >
              Bireysel Üyelik
            </Radio>
          </RadioGroup>
        </FormItem>

        <Button
          htmlType="submit"
          className="im-button im-button--primary im-button--fluid im-button--center mt-5 mb-5"
          label={t('next')}
        />
      </Form>
    </div>
  );
};

MembershipType.propTypes = {
  t: PropTypes.func,
  updateUserState: PropTypes.func,
  router: PropTypes.object,
  userState: PropTypes.object,
};

export default withTranslation('common')(MembershipType);
